import React from "react";
import { Paper, Popover, ClickAwayListener } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    pointerEvents: "auto",
    overflowWrap: "break-word",
    wordWrap: "break-word",
    maxWidth: "100%",
    whiteSpace: "normal",
  },
}));

const PopoverDisplay = ({
  anchorRef,
  popoverOpen,
  closePopover = () => {},
  children,
  popoverEnter,
  popoverLeave,
  marginTop = 10,
}) => {
  const classes = useStyles();
  return (
    <Popover
      id="mouse-over-popover"
      open={popoverOpen}
      anchorEl={anchorRef}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      className={classes.popover}
      classes={{
        paper: classes.popoverContent,
      }}
      PaperProps={{
        onMouseEnter: popoverEnter,
        onMouseLeave: popoverLeave,
        style: {
          backgroundColor: "transparent",
          maxWidth: "50vw",
        },
        elevation: 0,
      }}
      elevation={0}
    >
      <div
        style={{
          backgroundColor: "transparent",
          display: "flex",
          justifyContent: "center",
          marginTop,
          height: 18,
        }}
      ></div>
      <Paper
        className="break-word-text"
        style={{ backgroundColor: "transparent" }}
      >
        <ClickAwayListener onClickAway={closePopover}>
          <div className="pop-over-container break-word-text">{children}</div>
        </ClickAwayListener>
      </Paper>
    </Popover>
  );
};

export default PopoverDisplay;
